import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["themeInput"]

  connect() {
    this.apply()
  }

  apply() {
    const selectedInput = this.themeInputTargets.find((input) => input.checked)
    this.element.dataset.leaderBoardTheme = selectedInput?.value || "white"
  }
}
